import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContractApiService, UpdateContractRequestMutationInterface } from '@vendasta/billing';
import { Contract, contractFromApi } from './contract';

@Injectable({ providedIn: 'root' })
export class ContractService {
  constructor(private api: ContractApiService) {}

  /**
   * Get a contract by its identifier.
   *
   * @param merchantId is the unique identifier of the merchant.
   * @return An contract observable.
   */
  public get(merchantId: string): Observable<Contract> {
    return this.api.get({ merchantId }).pipe(map((c) => contractFromApi(c.contract)));
  }

  /**
   * Update a contract with a new value.
   *
   * @param merchantId is a string that identifies the contract to update.
   * @param mutations is a list of mutations to apply to the contract.
   * Each mutation object should only contain one value.
   * @return An observable of the update contract.
   */
  public update(merchantId: string, mutations: UpdateContractRequestMutationInterface[]): Observable<Contract> {
    return this.api.update({ merchantId, mutations }).pipe(map((c) => contractFromApi(c.contract)));
  }
}
